import { UserFieldErrorMessages } from "@constants/Errors";
import { TextInputField } from "@components/Inputs/TextInputField/TextInputField";
import { handleHiraganaKanaChange } from "@services/ErrorHandling";

export const YobelyGroupInfoCard = ({
  broadcastGroup,
  updateError,
  handleInputChange,
  errors,
}) => {
  return (
    <>
      <div className="mb-4">
        <TextInputField
          label="グループコード"
          placeholder="SHJ101"
          value={broadcastGroup?.code}
          required
          onChange={(e) => handleInputChange("code", e.target.value)}
        />
      </div>

      <div className="divider"></div>

      <div className="mb-4">
        <TextInputField
          label="グループ名"
          placeholder="新宿店"
          value={broadcastGroup?.name}
          required
          onChange={(e) => handleInputChange("name", e.target.value)}
        />
      </div>

      <div className="divider"></div>

      <div className="mb-4">
        <TextInputField
          label="グループ名(ふりがな)"
          placeholder="しんじゅくてん"
          value={broadcastGroup?.name_kana}
          onChange={(e) =>
            handleHiraganaKanaChange(
              "name_kana",
              e.target.value,
              handleInputChange,
              updateError,
            )
          }
        />
        {errors.name_kana && (
          <p className="text-red-500">{UserFieldErrorMessages.nameKanaError}</p>
        )}
      </div>
    </>
  );
};
